'use client';

import { I18nProvider as _I18nProvider } from '@crehana/i18n';

import { useLanguage } from '@/shared/components/language-provider';

// the useLanguage hook will return a language based on custom logic.
// this logic is related to the talent product and uses the user role and organization configuration to get the final value
export const I18nProviderWithLanguage = ({
  children,
}: React.PropsWithChildren) => {
  const language = useLanguage();
  return <_I18nProvider languageCode={language}>{children}</_I18nProvider>;
};
